import React from "react";
import { useState } from "react";
import '../HomePage/Quotes.css';
import '../HomePage/HomeInsurance.css';


const HomeDetail = ({ data }) => {

    return (
        <>
            <div className="Form_detail proposal_formdetail">
                <div className="home_detail2">
                    <h4>Home Details</h4>
                    {/*<div className="text-end OwnerEditbtn">
                        <button onClick="">
                            <img className="" src={data?.image} alt="Home Insurance at Lowest Rates" />
                            Edit
                        </button>
                    </div>*/}
                </div>
                <ul className="detail1 mb-0 p-0 text-center">
                    <li className="area_detail">
                        <small>Building Area</small>
                        <p><b>₹{data?.BuildingComponent?.areaOfBuilding}</b></p>
                    </li>
                    <li className="area_detail2">
                        <small>Rate per sq.ft</small>
                        <p><b>₹{Math.round(parseInt(data?.BuildingComponent?.valueOfBuilding) / parseInt(data?.BuildingComponent?.areaOfBuilding))}</b></p>
                    </li>
                    <li className="area_detail1">
                        <small>Value of building</small>
                        <p><b>₹{data?.BuildingComponent?.valueOfBuilding}</b></p>
                    </li>
                    {/*<li className="area_detail area_detail3">
                        <small>Value of Total content</small>
                        <p><b>₹{props?.data?.QuoteRes?.response[0]?.valueOfTotalContent}</b></p>
                    </li>*/}
                    <li className="area_detail2">
                        <div className="policy_term22">
                            <span className="d-block mt-2">Policy Term</span>
                            <p><b>{data?.policyTerm}</b></p>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    );
}
export default HomeDetail;